import { BsArrowDownRightCircle } from "react-icons/bs";
//import bannerImg from "../../../assets/bannerImg.jpg";
//import bannerVido from "../../../assets/videoplayback.webm";
import { useNavigate } from "react-router";
import commonObj from '../../../utils/Common';
import config from '../../../config/index';


const Banner = ({ catRef }) => {
  const navigate = useNavigate();

  return (
    <main className=" justify-between items-center mb-5  relative shocase-section px-[6%] ">
         <div className=" flex w-full justify-between items-center relative mainImg-div gap-6">
         <section className="xl:w-1/2 sm:mx-0 mx-2 w-full lg:w-1/2 mainImg-sec p-4">
        <img src={config.url+'bannerImg.jpg'} alt="bannerImg" className="w-full h-full" />
            <p className="py-1 text-md  text-gray-600">
        {commonObj.getLabel('BuySell_Text_1')}
          <br />
          {commonObj.getLabel('BuySell_Text_2')}
        </p>
        <div className=" flex  items-left lg:w-1/2 xl:w-1/2 relative buysell-div">
        {/* <button
            className="btn-primary   text-sm md:text-base"
            onClick={() => navigate("/products")}
          >
            {commonObj.getLabel('Start_Shopping')}
          </button> */}
          <button
            className="p-1 flex items-center"
            onClick={() =>
              catRef.current.scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="mx-2 text-sm md:text-base">{commonObj.getLabel('Explore_More')}</span>{" "}
            <BsArrowDownRightCircle className="text-lg" />
          </button>

        </div>

      
      </section>
          <section className="xl:w-1/2 sm:mx-0 mx-2 w-full lg:w-1/2 vido-sec p-4">
        {/* <img src={bannerImg} alt="bannerImg" className="w-1/1 h-full image-box-area" /> */}
        <video className="w-full video-box object-cover" controls >
        <source src={config.url+'videoplayback.webm'} type="video/mp4"/>
      </video>
      </section>
          </div> 
    </main>
  );
};

export default Banner;
